import { get, deleteRequest } from 'utils/fetch/fetchHelper'
import { ApiSession } from 'yordex-ui-kit'

export const fetchSession = () => get<ApiSession>('/sessions')

export const deleteSession = () => deleteRequest<void>('/sessions')
